import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { Link } from 'react-router-dom'

export const OverSection = styled(Box)`
    width: 96%;
    justify-content: center;
    align-items: start;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 96%;
        align-items: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 414px;
        flex-direction: column;
        justify-content: start;
        align-items: center;
    }
`

export const ContentSearch = styled(Box)`
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    align-items: center;
    gap: 200px;
    width: 100%;
    height: 40px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 60%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 50px;
        width: 100%;
    }
`

export const ContentSearchIcon = styled(Box)`
    width: 70px;
    height: 70px;
    position: absolute;
    top: 15px;
    left: 15px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Search = styled.input`
    width: 100%;
    padding: 0 40px;
    border-radius: 5px;
    background: ${({ theme }) => theme.colors.white};
    border: none;
    box-shadow: none;
    color: black;
    ::placeholder {
        font-family: inherit;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: white;
    }
    height: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const ContentInformation = styled(Box)`
    width: 100%;
    height: 601px;
    display: flex;
    flex-direction: column;
    border: 1px solid gray;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 60%;
        height: 601px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
        height: 601px;
    }
`
export const Information = styled(Box)`
    width: 95%;
    height: 100%;
    display: flex;
    flex-direction: column;

    overflow-y: scroll;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 90%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const TypographyTitle = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 37px;
    margin-bottom: 24px;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Card = styled(Link)`
    height: 60px;
    width: 100%;
    margin-bottom: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ImageCard = styled.img`
    width: 80px;
    height: 60px;
    object-fit: contain;
    border-radius: 5px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const CardContentInformation = styled(Box)`
    width: 240px;
    height: 60px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 260px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const CardTypographyTitle = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.white};
    width: 90%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const CardTypographyDate = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 14px;
    color: ${({ theme }) => theme.colors.white};
    margin-bottom: 5px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
